
let baseUrl = process.env.VUE_APP_INTEGRATOR_API
const { origin, hostname = '' } = location

if (hostname !== 'localhost') {
  baseUrl = origin
}

export default baseUrl
